import { useContext, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { useGetData } from "../../../../../hooks/useGetData";
import { useMutationData } from "../../../../../hooks/useMutationData";
import { EvaluadoInterface } from "../../../../../interfaces/EvaluadoInterface";
import { FechasOeInterface } from "../../../../../interfaces/FechasOeInterface";
import { SemaforoOeInterface } from "../../../../../interfaces/SemaforoOeInterface";
import { ConclusionesOEInterface } from "../../../../../interfaces/ConclusionesOEInterface";
import { Loading } from "../../../../../components/Loading/Loading";
import { Label, TextInput } from "flowbite-react";
import { Button } from "flowbite-react";
import { API } from "../../../../../global/global";
import Semaforo from "../../../../../img/Semaforo.png";
import Rojo from "../../../../../img/Rojo.png";
import Amarillo from "../../../../../img/Amarillo.png";
import Verde from "../../../../../img/Verde.png";
import Header from "../../../../../components/HeaderForms/HeaderForms";
import { ThemeContext } from "../../../../../components/ThemeContext/ThemeContext";

export const ConclusionesOEEditarScreen = () => {
  const { isDarkMode } = useContext(ThemeContext);
  const tituloFormulario = "CONCLUSIÓN DE OTRAS EVALUACIONES";
  const { control, reset, handleSubmit } = useForm();
  const { evaluadosList_id } = useParams<{ evaluadosList_id: string }>();
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [images, setImages] = useState<string[]>([""]);
  const [fechaNacimiento, setFechaNacimiento] = useState<string>("");
  const [edad, setEdad] = useState<number | null>(null);
  const [photoUrl, setPhotoUrl] = useState<string | null>(null);

  const [formData, setFormData] = useState({
    visitDate: "",
    name: "",
  });

  const calcularEdad = (fechaNacimiento: string) => {
    const fechaNac = new Date(fechaNacimiento);
    const hoy = new Date();
    let edadCalculada = hoy.getFullYear() - fechaNac.getFullYear();
    const mes = hoy.getMonth() - fechaNac.getMonth();

    if (mes < 0 || (mes === 0 && hoy.getDate() < fechaNac.getDate())) {
      edadCalculada--;
    }

    return edadCalculada;
  };

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    const updatedFormData = { ...formData, [name]: value };
    setFormData(updatedFormData);

    localStorage.setItem("formData", JSON.stringify(updatedFormData));
  };

  const handlePageChange = (newPage: number) => {
    const filledImages = images.filter((image) => image);
    setImages(filledImages.length > 0 ? filledImages : [""]);
    setCurrentPage(newPage);
  };

  const renderHeader = () => (
    <>
      {/* Header */}
      <Header titulo={tituloFormulario} />
    </>
  );

  const queryEvaluado = useGetData<EvaluadoInterface>({
    url: `/evaluado/${evaluadosList_id}`,
    name: ["evaluado"],
  });

  const queryFechaOE = useGetData<FechasOeInterface[]>({
    url: `/fechas_oe/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "fechas_oe"],
  });

  const mutateFechaOE = useMutationData({
    url: `/fechas_oe/${evaluadosList_id}`,
    reload: ["evaluado", `${evaluadosList_id}`, "fechas_oe"],
  });

  const querySemaforoOE = useGetData<SemaforoOeInterface>({
    url: `/semaforo_oe/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "semaforo_oe"],
  });

  const mutateSemaforoOE = useMutationData({
    url: `/semaforo_oe/${evaluadosList_id}`,
    reload: ["evaluado", `${evaluadosList_id}`, "semaforo_oe"],
  });

  const queryConclusionesOE = useGetData<ConclusionesOEInterface[]>({
    url: `/conclusiones_oe/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "conclusiones_oe"],
  });

  const mutateConclusionesOE = useMutationData({
    url: `/conclusiones_oe/${evaluadosList_id}`,
    reload: ["evaluado", `${evaluadosList_id}`, "conclusiones_oe"],
  });

  const normalizeString = (str: string) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  };

  const nombreCompleto = normalizeString(
    `${queryEvaluado.data?.nombre}_${queryEvaluado.data?.apellido_paterno}_${queryEvaluado.data?.apellido_materno}`.replace(
      /\s/g,
      "_"
    )
  );

  const [selectedImage, setSelectedImage] = useState(Semaforo);
  const [selectedRecommendation, setSelectedRecommendation] = useState<
    string | null
  >(null);

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setSelectedRecommendation(value);

    if (value === "recomendable") {
      setSelectedImage(Verde);
    } else if (value === "con_reserva") {
      setSelectedImage(Amarillo);
    } else if (value === "no_recomendable") {
      setSelectedImage(Rojo);
    }
  };

  useEffect(() => {
    if (queryEvaluado.data) {
      const fechaNac = queryEvaluado.data.fecha_nacimiento || "";
      setFechaNacimiento(fechaNac);

      const nuevaEdad = calcularEdad(fechaNac);
      setEdad(nuevaEdad);

      reset({
        nombre: queryEvaluado.data.nombre || "",
        apellido_paterno: queryEvaluado.data.apellido_paterno || "",
        apellido_materno: queryEvaluado.data.apellido_materno || "",
        rfc: queryEvaluado.data.rfc || "",
        genero: queryEvaluado.data.genero || "",
        estado_civil: queryEvaluado.data.estado_civil || "",
        escolaridad: queryEvaluado.data.escolaridad || "",
        fecha_nacimiento: fechaNac,
        curp: queryEvaluado.data.curp || "",
        empresa: queryEvaluado.data.empresa?.nombre || "",
      });
    }
  }, [queryEvaluado.data, reset]);

  useEffect(() => {
    if (evaluadosList_id) {
      const token = localStorage.getItem("token");
      fetch(`${API}/evaluados/${evaluadosList_id}/photo/${nombreCompleto}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.url) {
            setPhotoUrl(data.url);
          } else {
            setPhotoUrl(null);
          }
        })
        .catch((error) => {
          console.error("Error al obtener la URL de la foto:", error);
          setPhotoUrl(null);
        });
    }
  }, [evaluadosList_id, nombreCompleto]);

  useEffect(() => {
    if (queryFechaOE.data && queryFechaOE.data.length > 0) {
      const fechaoe = queryFechaOE.data[0];
      reset({
        conclusion_oe: fechaoe.conclusion_oe || "",
      });
    }
  }, [queryFechaOE.data, reset]);

  useEffect(() => {
    if (querySemaforoOE.data) {
      const color = querySemaforoOE.data.color_oe || "";

      let recommendation = "";
      if (color === "verde") {
        recommendation = "recomendable";
      } else if (color === "amarillo") {
        recommendation = "con_reserva";
      } else if (color === "rojo") {
        recommendation = "no_recomendable";
      }

      reset({
        color_oe: color,
        evaluado_uuid: querySemaforoOE.data.evaluado_uuid || "",
      });

      setSelectedRecommendation(recommendation);

      if (recommendation === "recomendable") {
        setSelectedImage(Verde);
      } else if (recommendation === "con_reserva") {
        setSelectedImage(Amarillo);
      } else if (recommendation === "no_recomendable") {
        setSelectedImage(Rojo);
      }
    }
  }, [querySemaforoOE.data, reset]);

  useEffect(() => {
    if (queryConclusionesOE.data && queryConclusionesOE.data.length > 0) {
      const notasOE = queryConclusionesOE.data[0];
      reset({
        motivo_oe: notasOE.motivo_oe || "",
        tipo_oe: notasOE.tipo_oe || "",
        descripcion_oe1: notasOE.descripcion_oe1 || "",
        descripcion_oe2: notasOE.descripcion_oe2 || "",
        descripcion_oe3: notasOE.descripcion_oe3 || "",
        descripcion_oe4: notasOE.descripcion_oe4 || "",
        resultado_oe: notasOE.resultado_oe || "",
        evaluado_uuid: notasOE.evaluado_uuid || "",
      });
    }
  }, [queryConclusionesOE.data, reset]);

  if (queryEvaluado.isLoading) {
    return <Loading />;
  }

  const renderPage1 = () => (
    <div className={`space-y-4 p-4 ${isDarkMode ? "bg-gray-800" : "bg-gray-50"}`}>
      <div className="grid grid-cols-3 gap-4">
        {/* Fecha Visita */}
        <div className="col-span-1 flex items-center">
          <Label htmlFor="conclusion_oe" className={`mr-2 ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
            FECHA EVALUACIÓN:
          </Label>
          <Controller
            name="conclusion_oe"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <TextInput
                id="conclusion_oe"
                type="date"
                value={
                  field.value ||
                  (queryFechaOE.data && queryFechaOE.data.length > 0
                    ? queryFechaOE.data[0]?.conclusion_oe || ""
                    : "")
                }
                onChange={(e) => field.onChange(e.target.value)}
                className={`text-center w-full ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-900 border-gray-300"}`}
              />
            )}
          />
        </div>
        {/* Campo para nombre */}
        <div className="col-span-2">
          <Label htmlFor="nombre" className={`${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>NOMBRE:</Label>
          <TextInput
            id="nombre"
            name="nombre"
            value={`${queryEvaluado.data?.nombre || ""} ${
              queryEvaluado.data?.apellido_paterno || ""
            } ${queryEvaluado.data?.apellido_materno || ""}`}
            onChange={handleInputChange}
            disabled={true}
            className={`${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-900 border-gray-300"}`}
          />
        </div>

        {/* FOTO */}
        <div className={`w-64 h-64 border rounded-md overflow-hidden flex items-center justify-center mt-4 relative z-10 ${isDarkMode ? "bg-gray-700 border-gray-600" : "bg-gray-100 border-gray-300"}`}>
          {photoUrl ? (
            <img
              src={photoUrl}
              alt="Foto de evaluado"
              className="w-full h-full object-cover"
            />
          ) : (
            <span className={`${isDarkMode ? "text-gray-300" : "text-gray-500"}`}>Sin foto disponible</span>
          )}
        </div>
        {/* SEMAFORO */}
        <div className="flex items-center gap-4">
          {/* Radio buttons */}
          <div className="flex flex-col">
            <label className={`flex items-center gap-2 mt-4 mb-4 ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
              <input
                type="radio"
                name="recommendation"
                value="recomendable"
                checked={selectedRecommendation === "recomendable"}
                onChange={handleRadioChange}
              />
              RECOMENDABLE
            </label>
            <label className={`flex items-center gap-2 mt-12 mb-12 ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
              <input
                type="radio"
                name="recommendation"
                value="con_reserva"
                checked={selectedRecommendation === "con_reserva"}
                onChange={handleRadioChange}
              />
              CON RESERVA
            </label>
            <label className={`flex items-center gap-2 mb-12 ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
              <input
                type="radio"
                name="recommendation"
                value="no_recomendable"
                checked={selectedRecommendation === "no_recomendable"}
                onChange={handleRadioChange}
              />
              NO RECOMENDABLE
            </label>
          </div>
          {/* Imagen de Semaforo */}
          <img src={selectedImage} alt="Semaforo" className="w-70 h-70" />
        </div>
      </div>

      <div className="grid grid-cols-3 gap-4">
        {/* Campo para RFC */}
        <div className="col-span-1">
          <Label htmlFor="rfc" className={`${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>RFC:</Label>
          <TextInput
            id="rfc"
            name="rfc"
            onChange={handleInputChange}
            value={queryEvaluado.data?.rfc || ""}
            disabled={true}
            className={`${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-900 border-gray-300"}`}
          />
        </div>
        {/* Edad */}
        <div className="col-span-1">
          <Label htmlFor="edad" className={`${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>EDAD:</Label>
          <TextInput
            id="edad"
            name="edad"
            value={edad !== null ? edad.toString() : ""}
            disabled={true}
            className={`${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-900 border-gray-300"}`}
          />
        </div>
        {/* Género */}
        <div className="col-span-1">
          <Label htmlFor="sexo" className={`${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>SEXO:</Label>
          <TextInput
            id="sexo"
            name="sexo"
            onChange={handleInputChange}
            value={queryEvaluado.data?.genero || ""}
            disabled={true}
            className={`${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-900 border-gray-300"}`}
          />
        </div>
        {/* Estado Civil */}
        <div className="col-span-1">
          <Label htmlFor="estadoCivil" className={`${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>ESTADO CIVIL:</Label>
          <TextInput
            id="estadoCivil"
            name="estadoCivil"
            onChange={handleInputChange}
            value={queryEvaluado.data?.estado_civil || ""}
            disabled={true}
            className={`${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-900 border-gray-300"}`}
          />
        </div>
        {/* Escolaridad */}
        <div className="col-span-1">
          <Label htmlFor="escolaridad" className={`${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>ESCOLARIDAD:</Label>
          <TextInput
            id="escolaridad"
            name="escolaridad"
            onChange={handleInputChange}
            value={queryEvaluado.data?.escolaridad || ""}
            disabled={true}
            className={`${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-900 border-gray-300"}`}
          />
        </div>
        {/* Fecha de Nacimiento */}
        <div className="col-span-1 flex items-center">
          <Label htmlFor="fechaNacimiento" className={`mr-2 ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
            FECHA DE NACIMIENTO:
          </Label>
          <TextInput
            id="fechaNacimiento"
            name="fechaNacimiento"
            value={queryEvaluado.data?.fecha_nacimiento || ""}
            disabled={true}
            type="date"
            className={`w-32 ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-900 border-gray-300"}`}
          />
        </div>
        {/* CURP */}
        <div className="col-span-1">
          <Label htmlFor="curp" className={`${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>CURP:</Label>
          <TextInput
            id="curp"
            name="curp"
            onChange={handleInputChange}
            value={queryEvaluado.data?.curp || ""}
            disabled={true}
            className={`${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-900 border-gray-300"}`}
          />
        </div>
        {/* Empresa */}
        <div className="col-span-1">
          <Label htmlFor="empresa" className={`${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>EMPRESA:</Label>
          <TextInput
            id="empresa_id"
            name="empresa"
            value={queryEvaluado.data?.empresa_id?.nombre || ""}
            onChange={handleInputChange}
            disabled={true}
            className={`${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-900 border-gray-300"}`}
          />
        </div>
        {/* Motivo de la evaluación */}
        <div className="col-span-1">
          <Label htmlFor="motivo_oe" className={`${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>MOTIVO DE LA EVALUACIÓN:</Label>
          <Controller
            name="motivo_oe"
            control={control}
            defaultValue={
              queryConclusionesOE.data && queryConclusionesOE.data.length > 0
                ? queryConclusionesOE.data[0]?.motivo_oe || ""
                : ""
            }
            render={({ field }) => (
              <TextInput
                id="motivo_oe"
                type="text"
                {...field}
                onChange={(e) => field.onChange(e.target.value)}
                className={`w-full ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-900 border-gray-300"}`}
              />
            )}
          />
        </div>
        <div className="col-span-1">
          <Label htmlFor="tipo_oe" className={`${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>TIPO:</Label>
          <Controller
            name="tipo_oe"
            control={control}
            defaultValue={
              queryConclusionesOE.data && queryConclusionesOE.data.length > 0
                ? queryConclusionesOE.data[0]?.tipo_oe || ""
                : ""
            }
            render={({ field }) => (
              <select
                {...field}
                id="tipo_oe"
                className={`w-full p-2 border rounded focus:outline-none focus:ring-2 ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600 focus:ring-blue-400" : "bg-white text-gray-900 border-gray-300 focus:ring-blue-500"}`}
              >
                <option value="">Selecciona una opción</option>
                <option value="Nuevo Ingreso">Nuevo Ingreso</option>
                <option value="Permanencia">Permanencia</option>
                <option value="Ascenso">Ascenso</option>
                <option value="Otro">Otro</option>
              </select>
            )}
          />
        </div>
      </div>
    </div>
  );

  const renderPage2 = () => (
    <div className={`space-y-6 p-6 rounded-lg shadow-md ${isDarkMode ? "bg-gray-800" : "bg-gray-50"}`}>
      <div className="bg-customBlue text-white p-4 rounded-lg shadow">
        <h2 className="font-bold text-xl">RESULTADO GENERAL</h2>
      </div>

      <div className={`flex flex-col items-center border-dashed border-4 rounded-lg p-8 space-y-4 relative ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300 bg-gray-100"}`}>
        {/* Área para agregar notas */}
        <div className="w-full mt-4">
          <span className={`mb-2 text-justify block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
            Se realizó una valoración, análisis y revisión con la finalidad de
            identificar los riesgos en conjunto, dado lo anterior se encontró lo
            siguiente en el proceso de evaluación:
          </span>
          <span className={`mb-2 text-justify block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
            Se considera que es una{" "}
            <strong>
              PERSONA{" "}
              <Controller
                name="descripcion_oe1"
                control={control}
                defaultValue={
                  queryConclusionesOE.data &&
                  queryConclusionesOE.data.length > 0
                    ? queryConclusionesOE.data[0]?.descripcion_oe1 || ""
                    : ""
                }
                render={({ field }) => (
                  <input
                    id="descripcion_oe1"
                    type="text"
                    {...field}
                    onChange={(e) => field.onChange(e.target.value)}
                    placeholder="Escribe aquí..."
                    className={`w-[400px] border rounded-lg p-2 focus:outline-none resize-none ${isDarkMode ? "bg-gray-600 text-gray-200 border-gray-500 focus:border-blue-400" : "bg-white text-gray-900 border-gray-300 focus:border-blue-500"}`}
                  />
                )}
              />
            </strong>{" "}
            ya que:
          </span>
          <Controller
            name="descripcion_oe2"
            control={control}
            defaultValue={
              queryConclusionesOE.data && queryConclusionesOE.data.length > 0
                ? queryConclusionesOE.data[0]?.descripcion_oe2 || ""
                : ""
            }
            render={({ field }) => (
              <textarea
                {...field}
                id="descripcion_oe2"
                onInput={(e) => {
                  const target = e.target as HTMLTextAreaElement;
                  target.style.height = "auto";
                  target.style.height = `${target.scrollHeight}px`;
                }}
                style={{
                  height: "auto",
                  overflow: "hidden",
                  textAlign: "justify",
                }}
                placeholder="Escribe tus notas aquí..."
                className={`w-full border rounded-lg p-2 focus:outline-none resize-none ${isDarkMode ? "bg-gray-600 text-gray-200 border-gray-500 focus:border-blue-400" : "bg-white text-gray-900 border-gray-300 focus:border-blue-500"}`}
                rows={30}
              />
            )}
          />
          <span className={`mt-2 mb-2 text-justify block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
            Al momento de la evaluación se observó también lo siguiente:
          </span>
          <Controller
            name="descripcion_oe3"
            control={control}
            defaultValue={
              queryConclusionesOE.data && queryConclusionesOE.data.length > 0
                ? queryConclusionesOE.data[0]?.descripcion_oe3 || ""
                : ""
            }
            render={({ field }) => (
              <textarea
                {...field}
                id="descripcion_oe3"
                onInput={(e) => {
                  const target = e.target as HTMLTextAreaElement;
                  target.style.height = "auto";
                  target.style.height = `${target.scrollHeight}px`;
                }}
                style={{
                  height: "auto",
                  overflow: "hidden",
                  textAlign: "justify",
                }}
                placeholder="Escribe tus notas aquí..."
                className={`w-full border rounded-lg p-2 focus:outline-none resize-none ${isDarkMode ? "bg-gray-600 text-gray-200 border-gray-500 focus:border-blue-400" : "bg-white text-gray-900 border-gray-300 focus:border-blue-500"}`}
                rows={30}
              />
            )}
          />
        </div>
      </div>

      <div className="grid grid-cols-1 gap-4">
        {/* Campo Resultado */}
        <div className="col-span-1">
          <Label htmlFor="resultado_oe" className={`${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>RESULTADO:</Label>
          <br />
          <Controller
            name="resultado_oe"
            control={control}
            defaultValue={
              queryConclusionesOE.data && queryConclusionesOE.data.length > 0
                ? queryConclusionesOE.data[0]?.resultado_oe || ""
                : ""
            }
            render={({ field }) => (
              <input
                type="text"
                id="resultado_oe"
                {...field}
                onChange={(e) => field.onChange(e.target.value)}
                className={`text-left w-auto border rounded ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-900 border-gray-300"}`}
              />
            )}
          />
        </div>
      </div>
    </div>
  );

  return (
    <div className={`min-h-screen ${isDarkMode ? "bg-gray-900" : "bg-gray-50"}`}>
      <div className="container mx-auto p-4">
        <form
          onSubmit={handleSubmit((data) => {
            const formData = {
              ...data,
              recomendacion: selectedRecommendation,
              color_oe:
                selectedRecommendation === "recomendable"
                  ? "verde"
                  : selectedRecommendation === "con_reserva"
                  ? "amarillo"
                  : selectedRecommendation === "no_recomendable"
                  ? "rojo"
                  : "",
            };

            // Guardar Fecha de Otras Evaluaciones
            mutateFechaOE.mutate(
              {
                data: Object.fromEntries(
                  Object.entries(formData).filter(
                    ([key, value]) =>
                      value !== undefined && value !== null && value !== ""
                  )
                ),
                tipo: "put",
              },
              {
                onSuccess: () => {
                  console.log(
                    "Fecha de Otras Evaluaciones actualizada con éxito"
                  );
                },
                onError: (error) => {
                  console.error(
                    "Error al guardar Fecha de Otras Evaluaciones:",
                    error
                  );
                },
              }
            );

            // Guardar Semáforo de Otras Evaluaciones
            mutateSemaforoOE.mutate(
              {
                data: formData,
                tipo: "put",
              },
              {
                onSuccess: () => {
                  console.log(
                    "Semáforo de Otras Evaluaciones guardado con éxito"
                  );
                },
                onError: (error) => {
                  console.error(
                    "Error al guardar Semáforo de Otras Evaluaciones:",
                    error
                  );
                },
              }
            );

            // Guardar Conclusión de otras evaluaciones
            mutateConclusionesOE.mutate(
              {
                data: Object.fromEntries(
                  Object.entries(formData).filter(
                    ([key, value]) =>
                      value !== undefined && value !== null && value !== ""
                  )
                ),
                tipo: "put",
              },
              {
                onSuccess: () => {
                  navigate(`/otras_evaluacionesLinea/${evaluadosList_id}`);
                  console.log(
                    "Conclusión de Otras Evaluaciones actualizada con éxito"
                  );
                },
                onError: (error) => {
                  console.error(
                    "Error al guardar Conclusión de Otras Evaluaciones:",
                    error
                  );
                },
              }
            );
          })}
          className={`max-w-4xl mx-auto rounded-lg shadow-lg overflow-hidden ${isDarkMode ? "bg-gray-800" : "bg-white"}`}
        >
          {renderHeader()}

          {currentPage === 1 && renderPage1()}
          {currentPage === 2 && renderPage2()}

          <div className={`mt-6 p-4 flex justify-between ${isDarkMode ? "bg-gray-800" : "bg-white"}`}>
            {currentPage === 1 && (
              <Button
                onClick={() => {
                  window.scrollTo(0, 0);
                  navigate(`/otras_evaluacionesLinea/${evaluadosList_id}`);
                }}
                className={`ml-2 ${isDarkMode ? "bg-red-600 text-white hover:bg-red-800" : "bg-blue-500 text-white hover:bg-red-600"}`}
              >
                Cancelar
              </Button>
            )}

            {currentPage > 1 && (
              <Button
                onClick={() => {
                  window.scrollTo(0, 0);
                  handlePageChange(currentPage - 1);
                }}
                className={`ml-2 ${isDarkMode ? "bg-violet-600 text-white hover:bg-violet-800" : "bg-violet-500 text-white hover:bg-violet-600"}`}
              >
                Anterior
              </Button>
            )}

            {currentPage < 2 && (
              <Button
                type="button"
                className={`ml-2 ${isDarkMode ? "bg-blue-600 text-gray-100 hover:bg-blue-700" : "bg-blue-500 text-white hover:bg-blue-600"}`}
                onClick={() => {
                  window.scrollTo(0, 0);
                  handlePageChange(currentPage + 1);
                }}
              >
                Siguiente
              </Button>
            )}

            {/* Botón Guardar */}
            {currentPage === 2 && (
              <div className="flex space-x-4">
                <Button
                  type="submit"
                  className={`ml-2 ${isDarkMode ? "bg-green-600 text-gray-100 hover:bg-green-700" : "bg-green-500 text-white hover:bg-green-600"}`}
                >
                  Guardar
                </Button>
              </div>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};
